module.exports = __webpack_public_path__ + "static/media/projectsCover.dc8652c6.jpg";